import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

/* ─── animation presets ─── */
const fadeUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.8, ease: "easeOut" },
};

const stagger = (delay = 0) => ({
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.8, ease: "easeOut", delay },
});

const eventTypes = [
  {
    title: "الأفراح",
    desc: "كل تفاصيل ليلة العمر",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQXzl7Tydn2_KWrQKCEN927_AW3MeObsOh0mA&s",
    link: "/afrah",
  },
  {
    title: "الخطوبة",
    desc: "سجّل فرحة البدايات",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRuMaaNdQL_pU_nC4ymQqYURKvXW9ueYzVKyg&s",
    link: "/khotoba",
  },
  {
    title: "كتب الكتاب",
    desc: "وثّق اللحظات الرسمية",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQPQkoXsng1IRTgORViJU188Ql5_pHTQotsvg&s",
    link: "/katb-ketab",
  },
  {
    title: "التخرج",
    desc: "فرحة النجاح مع أصحابك",
    img: "https://phth.horus.edu.eg/wp-content/uploads/2025/03/02-59-scaled.jpg",
    link: "/graduation",
  },
  {
    title: "أعياد الميلاد",
    desc: "لمة العيلة والأحباب",
    img: "https://lh3.googleusercontent.com/aida-public/AB6AXuCIITwhdQxWYPIsbOb-ktyy1kwuHMfHxZdEw0DosMZ1txsizCCXzGAe4BbqMJTgd-H1x85v0sM-J-SHW6mq0wlQMPaq8DE7xdPTWS5GBlHYyoC5DV1R1yvaRg7Dos4pYxCpmYX3nfqgrUkXLDlR35iqz2d5z2zCS92lOCtZmC7XDGjyNlT4QnA_ztQ2FRdgalBjMj2bzNH0Y7pb1y6hA2MEmmE8wRwCwEmnGG_9-xs-QgpuQfT_PypCwHVZ2061XDUDi1xBX7nU1VoK",
    link: "#",
  },
];

const features = [
  {
    icon: "qr_code_2",
    title: "سهولة الـ QR كود",
    desc: "الضيوف مش محتاجين يسجلوا أو يحملوا أي برامج. بمسحة واحدة للكود من الموبايل، الكل بيبدأ يشارك صوره وفيديوهاته فوراً.",
  },
  {
    icon: "mic_external_on",
    title: "سجل زوار صوتي",
    desc: "اترك للضيوف مساحة للتعبير عن تهنئتهم برسائل صوتية حقيقية. مش بس صور، دي مشاعر هتفضل محفورة للأبد.",
  },
  {
    icon: "hd",
    title: "أعلى جودة للصور",
    desc: "بنحافظ على جودة الصور الأصلية زي ما هي. مفيش أي تقليل للجودة زي واتساب، عشان تقدر تطبع ذكرياتك بأحسن شكل.",
  },
];

const faqs = [
  {
    q: "إزاي الضيوف بيشاركوا صورهم؟",
    a: "ببساطة شديدة، الضيوف بيمسحوا الـ QR كود الموجود في القاعة، بيفتح لهم صفحة يومك، بيختاروا الصور من موبايلهم وبيدوسوا \"إرسال\". مفيش أسهل من كده!",
  },
  {
    q: "الصور بتفضل متاحة لحد إمتى؟",
    a: "الصور بتفضل موجودة على حسابك للأبد. تقدر ترجعلها في أي وقت، تحملها كلها بضغطة واحدة، وتتفرج عليها في ذكرى فرحك السنوية.",
  },
  {
    q: "ينفع أمسح صورة مش عجباني؟",
    a: "أكيد، بصفتك منظم المناسبة هيكون معاك لوحة تحكم كاملة تقدر من خلالها تراجع الصور، توافق على اللي يظهر، وتمسح أي صورة تلاقيها مش مناسبة.",
  },
];

export default function LandingPage() {
  return (
    <div className="landing-page" dir="rtl">
      {/* ══════════════ HERO ══════════════ */}
      <section className="relative pt-5 pb-5 md:pt-56 md:pb-40 hero-gradient" style={{ background: 'var(--grad-hero)' }}>
        <div className="container px-4 text-center relative z-10">
          <motion.div
            className="d-inline-flex align-items-center gap-2 px-4 py-2 rounded-pill text-xs font-bold mb-4"
            style={{ backgroundColor: 'var(--primary-dim)', color: 'var(--primary)', fontSize: '0.75rem' }}
            {...fadeUp}
          >
            <span className="material-symbols-outlined" style={{ fontSize: '1rem' }}>celebration</span>
            المنصة الأولى لتنظيم ذكريات الأفراح في مصر
          </motion.div>

          <motion.h1
            className="display-4 display-md-2 fw-black mb-4 leading-tight"
            style={{ fontFamily: 'var(--font-headline)', fontWeight: 900 }}
            {...fadeUp}
          >
            كل صور مناسبتك<br />
            <span className="text-primary position-relative d-inline-block">
              في مكان واحد
              <svg className="position-absolute start-0 w-100" style={{ bottom: '-10px' }} fill="none" height="12" viewBox="0 0 400 12" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 10C100 2 300 2 398 10" stroke="#8b493e" strokeLinecap="round" strokeWidth="4"></path>
              </svg>
            </span>
          </motion.h1>

          <motion.p
            className="fs-4 text-on-surface-variant mx-auto mb-5 arabic-leading"
            style={{ maxWidth: '768px' }}
            {...stagger(0.1)}
          >
            مع يومك، ضيوفك هيصوروا ويشاركوا أحلى اللحظات في ألبوم واحد فوري. مفيش داعي لتحميل تطبيقات، الرابط أو الـ QR كود كفاية.
          </motion.p>

          <motion.div
            className="d-flex flex-column flex-sm-row justify-content-center gap-3"
            {...stagger(0.2)}
          >
            <Link to="/register" className="btn btn-primary px-5 py-3 fs-5 shadow-lg">
              ابدأ تجربتك المجانية
            </Link>
            <Link to="/login" className="btn btn-outline-primary px-5 py-3 fs-5">
              عرض تجريبي للمناسبة
            </Link>
          </motion.div>
        </div>
      </section>

      {/* ══════════════ EVENT TYPES ══════════════ */}
      <section className="py-5 bg-surface" id="events">
        <div className="container px-4">
          <div className="text-center mb-5">
            <motion.h2 className="display-4 fw-black mb-3" style={{ fontFamily: 'var(--font-headline)', fontWeight: 900 }} {...fadeUp}>لكل مناسباتك السعيدة</motion.h2>
            <motion.p className="text-on-surface-variant fs-5 mx-auto arabic-leading" style={{ maxWidth: '600px' }} {...fadeUp}>صممنا يومك ليناسب كل احتفالاتك الخاصة بجودة ولمسة مصرية راقية</motion.p>
          </div>

          <div className="row g-3 g-md-4">
            {eventTypes.map((type, i) => (
              <div key={i} className="col-6 col-md-4 col-lg">
                <Link to={type.link} className="text-decoration-none">
                  <motion.div
                    className="card border-0 rounded-4 overflow-hidden position-relative h-100 transition-soft"
                    style={{ aspectRatio: '3/4' }}
                    whileHover={{ y: -10 }}
                    {...fadeUp}
                  >
                    <img src={type.img} alt={type.title} className="position-absolute w-100 h-100 object-cover" />
                    <div className="position-absolute top-0 start-0 w-100 h-100" style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.8) 0%, transparent 60%)' }}></div>
                    <div className="position-absolute bottom-0 end-0 p-4 text-white text-end">
                      <h3 className="h4 fw-bold mb-1">{type.title}</h3>
                      <p className="small mb-0 opacity-80">{type.desc}</p>
                    </div>
                  </motion.div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══════════════ FEATURES ══════════════ */}
      <section className="py-5 bg-surface-variant" id="features">
        <div className="container px-4">
          <div className="row align-items-end mb-5 g-4">
            <div className="col-md-8">
              <motion.h2 className="display-5 fw-black mb-3" style={{ fontFamily: 'var(--font-headline)', fontWeight: 900 }} {...fadeUp}>ليه تختار يومك لمناسبة العمر؟</motion.h2>
              <motion.p className="text-on-surface-variant fs-5 arabic-leading mb-0" {...fadeUp}>بنقدم لك تجربة متميزة بتجمع بين سهولة الاستخدام وأناقة العرض.</motion.p>
            </div>
            <div className="col-md-4 d-none d-md-block text-end">
              <div className="d-inline-block rounded-pill" style={{ width: '100px', height: '6px', backgroundColor: 'var(--primary)' }}></div>
            </div>
          </div>

          <div className="row g-4">
            {features.map((feature, i) => (
              <div key={i} className="col-lg-4">
                <motion.div
                  className="bg-white p-5 rounded-4 h-100 shadow-sm border border-light transition-soft"
                  whileHover={{ y: -5, boxShadow: 'var(--shadow-lg)' }}
                  {...fadeUp}
                >
                  <div className="rounded-4 d-flex align-items-center justify-content-center mb-4" style={{ width: '80px', height: '80px', backgroundColor: 'var(--primary-dim)', color: 'var(--primary)' }}>
                    <span className="material-symbols-outlined" style={{ fontSize: '40px' }}>{feature.icon}</span>
                  </div>
                  <h3 className="h3 fw-bold mb-3">{feature.title}</h3>
                  <p className="text-on-surface-variant arabic-leading mb-0">{feature.desc}</p>
                </motion.div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══════════════ HOW IT WORKS ══════════════ */}
      <section className="py-5 bg-white">
        <div className="container px-4">
          <div className="text-center mb-5">
            <motion.h2 className="display-4 fw-black mb-3" style={{ fontFamily: 'var(--font-headline)', fontWeight: 900 }} {...fadeUp}>ألبومك الرقمي في ٣ خطوات</motion.h2>
            <motion.p className="text-on-surface-variant fs-5 mx-auto arabic-leading" style={{ maxWidth: '600px' }} {...fadeUp}>بدون تطبيقات، بدون تعقيد، وبدون تسجيل دخول للضيوف.</motion.p>
          </div>
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <div className="d-flex flex-column gap-5">
                {[
                  { n: "١", t: "أنشئ معرضك في دقيقة", d: "اختر اسم المناسبة وخصص صفحة الاستقبال بلمستك الشخصية. بمجرد الاشتراك، الباركود بتاعك بيكون جاهز فوراً." },
                  { n: "٢", t: "الضيوف بيمسحوا ويصوروا", d: "بمسحة سريعة للـ QR كود، الضيوف بيقدروا يرفعوا صورهم وفيديوهاتهم من غير ما يحملوا أي تطبيق أو يعملوا حساب." },
                  { n: "٣", t: "حمل ذكرياتك بضغطة واحدة", d: "كل اللحظات بتتحفظ بجودتها الأصلية. تقدر تحمل كل الصور والفيديوهات في ملف واحد ZIP في أي وقت." }
                ].map((step, i) => (
                  <motion.div key={i} className="d-flex gap-4" {...fadeUp}>
                    <div className={`rounded-4 d-flex align-items-center justify-content-center fw-bold fs-3 flex-shrink-0 transition-soft`}
                         style={{ width: '64px', height: '64px', backgroundColor: i === 0 ? 'var(--primary)' : 'var(--primary-dim)', color: i === 0 ? 'white' : 'var(--primary)', boxShadow: i === 0 ? 'var(--shadow-md)' : 'none' }}>
                      {step.n}
                    </div>
                    <div>
                      <h4 className="h4 fw-bold mb-2">{step.t}</h4>
                      <p className="text-on-surface-variant fs-5 arabic-leading mb-0">{step.d}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
            <div className="col-lg-6">
              <motion.div className="position-relative p-4" {...fadeUp}>
                <div className="position-absolute top-0 start-0 w-100 h-100 rounded-5 blur-2xl" style={{ backgroundColor: 'rgba(139, 73, 62, 0.1)', transform: 'rotate(-3deg) scale(0.95)', zIndex: -1 }}></div>
                <div className="bg-white p-3 rounded-5 shadow-2xl border border-light">
                  <img src="https://lh3.googleusercontent.com/aida-public/AB6AXuDFHx0gpgkaMlQOP4Ri83JM3hfoXd9V4wyXXHlbqOv_QBJOw339DRmN7LGCK0mn4ktQZEm4wlB6JqCj0OJEm-zLq7mXBFMRKoUwxVVgxkRndADfV7mlleU8OVPHFWiGPF4nMPfrjTqz0wI4NdTcNxROU3VCEeFZGpzcPNsptQVnw1OUMoAGvQKt5zdSZybsJARfGysuVWVxBdHxZrGoWHB8ZW7sD_43pp1lTAIcRag2NZT4goGDxdfIYeLzL-gGLw_r2b9XlRTIYRa9" alt="QR Interaction" className="w-100 rounded-4 shadow-inner" />
                  <div className="position-absolute bottom-0 end-0 bg-white p-4 rounded-4 shadow-lg border border-light m-4" style={{ maxWidth: '280px' }}>
                    <div className="d-flex align-items-center gap-2 mb-2">
                      <span className="position-relative d-flex" style={{ width: '12px', height: '12px' }}>
                        <span className="animate-ping position-absolute h-100 w-100 rounded-circle bg-primary opacity-75"></span>
                        <span className="position-relative rounded-circle h-100 w-100 bg-primary"></span>
                      </span>
                      <span className="text-primary fw-black small text-uppercase tracking-wider">تحديث مباشر</span>
                    </div>
                    <p className="fw-bold mb-0">وصلت ٢٤ صورة جديدة من طاولات الأفراح الآن!</p>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* ══════════════ PRICING ══════════════ */}
      <section className="py-5 bg-surface-variant" id="pricing">
        <div className="container px-4">
          <div className="text-center mb-5">
            <motion.h2 className="display-4 fw-black mb-3" style={{ fontFamily: 'var(--font-headline)', fontWeight: 900 }} {...fadeUp}>أسعار بسيطة، ذكريات تدوم للأبد</motion.h2>
            <motion.p className="text-on-surface-variant fs-5 mx-auto arabic-leading" style={{ maxWidth: '600px' }} {...fadeUp}>اختر الباقة المناسبة لمناسبتك وابدأ في جمع أجمل اللحظات مع ضيوفك في ثوانٍ.</motion.p>
          </div>

          <div className="row g-4 justify-content-center align-items-stretch">
            {/* Plan 1: Free */}
            <div className="col-lg-3 col-md-6">
              <motion.div className="bg-white p-4 rounded-4 shadow-sm border border-light h-100 d-flex flex-column transition-soft" whileHover={{ y: -10 }} {...fadeUp}>
                <div className="mb-4">
                  <h3 className="h4 fw-bold mb-2">الخطة المجانية</h3>
                  <div className="d-flex align-items-baseline gap-1">
                    <span className="display-5 fw-black text-primary">0</span>
                    <span className="text-on-surface-variant fw-bold">ج.م</span>
                  </div>
                </div>
                <ul className="list-unstyled space-y-3 mb-4 flex-grow-1 text-end">
                  <li className="d-flex align-items-center gap-2 small"><span className="material-symbols-outlined text-primary text-sm">check_circle</span> مناسبة واحدة (Event)</li>
                  <li className="d-flex align-items-center gap-2 small"><span className="material-symbols-outlined text-primary text-sm">check_circle</span> صفحة أساسية للمناسبة</li>
                  <li className="d-flex align-items-center gap-2 small"><span className="material-symbols-outlined text-primary text-sm">check_circle</span> QR كود متاح</li>
                  <li className="d-flex align-items-center gap-2 small"><span className="material-symbols-outlined text-primary text-sm">check_circle</span> أقصى حد 10 صور</li>
                  <li className="d-flex align-items-center gap-2 small opacity-50"><span className="material-symbols-outlined text-sm">info</span> علامة يومك المائية</li>
                </ul>
                <Link to="/register" className="btn btn-outline-primary w-100 py-3 fw-bold">ابدأ مجاناً</Link>
              </motion.div>
            </div>

            {/* Plan 2: Starter */}
            <div className="col-lg-3 col-md-6">
              <motion.div className="bg-white p-4 rounded-4 shadow-lg border-2 border-primary h-100 d-flex flex-column position-relative transition-soft scale-105" whileHover={{ y: -10 }} {...fadeUp}>
                <div className="position-absolute top-0 start-50 translate-middle badge rounded-pill bg-primary px-3 py-1 small fw-black shadow">الأكثر طلباً 🔥</div>
                <div className="mb-4 mt-2">
                  <h3 className="h4 fw-bold mb-2">باقة البداية</h3>
                  <div className="d-flex align-items-baseline gap-2">
                    <span className="display-5 fw-black text-primary">99</span>
                    <span className="text-decoration-line-through text-on-surface-variant opacity-50 fw-bold">198</span>
                    <span className="text-on-surface-variant fw-bold">ج.م</span>
                  </div>
                </div>
                <ul className="list-unstyled space-y-3 mb-4 flex-grow-1 text-end">
                  <li className="d-flex align-items-center gap-2 small fw-bold"><span className="material-symbols-outlined text-primary text-sm">check_circle</span> عدد غير محدود من الصور</li>
                  <li className="d-flex align-items-center gap-2 small"><span className="material-symbols-outlined text-primary text-sm">check_circle</span> ألوان مخصصة للتصميم</li>
                  <li className="d-flex align-items-center gap-2 small"><span className="material-symbols-outlined text-primary text-sm">check_circle</span> بدون علامة مائية</li>
                  <li className="d-flex align-items-center gap-2 small"><span className="material-symbols-outlined text-primary text-sm">check_circle</span> QR كود متقدم</li>
                  <li className="d-flex align-items-center gap-2 small"><span className="material-symbols-outlined text-primary text-sm">check_circle</span> إمكانية تحميل الصور</li>
                </ul>
                <Link to="/register" className="btn btn-primary w-100 py-3 fw-bold shadow-lg shadow-primary-dim">اشترك الآن</Link>
              </motion.div>
            </div>

            {/* Plan 3: Pro */}
            <div className="col-lg-3 col-md-6">
              <motion.div className="bg-white p-4 rounded-4 shadow-sm border border-light h-100 d-flex flex-column transition-soft" whileHover={{ y: -10 }} {...fadeUp}>
                <div className="mb-4">
                  <h3 className="h4 fw-bold mb-2">الباقة الاحترافية</h3>
                  <div className="d-flex align-items-baseline gap-2">
                    <span className="display-5 fw-black text-primary">249</span>
                    <span className="text-decoration-line-through text-on-surface-variant opacity-50 fw-bold">498</span>
                    <span className="text-on-surface-variant fw-bold">ج.م</span>
                  </div>
                </div>
                <ul className="list-unstyled space-y-3 mb-4 flex-grow-1 text-end">
                  <li className="d-flex align-items-center gap-2 small fw-bold"><span className="material-symbols-outlined text-primary text-sm">star</span> كل مميزات باقة البداية</li>
                  <li className="d-flex align-items-center gap-2 small"><span className="material-symbols-outlined text-primary text-sm">check_circle</span> نظام RSVP للمدعوين</li>
                  <li className="d-flex align-items-center gap-2 small"><span className="material-symbols-outlined text-primary text-sm">check_circle</span> تحليلات متقدمة للمناسبة</li>
                  <li className="d-flex align-items-center gap-2 small"><span className="material-symbols-outlined text-primary text-sm">check_circle</span> نطاق مخصص (Domain)</li>
                  <li className="d-flex align-items-center gap-2 small"><span className="material-symbols-outlined text-primary text-sm">check_circle</span> قوالب متميزة (Premium)</li>
                </ul>
                <Link to="/register" className="btn btn-outline-primary w-100 py-3 fw-bold">اشترك الآن</Link>
              </motion.div>
            </div>

            {/* Plan 4: Corporate */}
            <div className="col-lg-3 col-md-6">
              <motion.div className="bg-surface-container-low p-4 rounded-4 shadow-sm border border-light h-100 d-flex flex-column transition-soft" whileHover={{ y: -10 }} {...fadeUp}>
                <div className="mb-4">
                  <h3 className="h4 fw-bold mb-2">باقة الشركات</h3>
                  <div className="d-flex align-items-baseline gap-2">
                    <span className="display-5 fw-black text-primary">999</span>
                    <span className="text-decoration-line-through text-on-surface-variant opacity-50 fw-bold">1998</span>
                    <span className="text-on-surface-variant fw-bold text-xs">ج.م/شهر</span>
                  </div>
                </div>
                <ul className="list-unstyled space-y-3 mb-4 flex-grow-1 text-end">
                  <li className="d-flex align-items-center gap-2 small"><span className="material-symbols-outlined text-primary text-sm">check_circle</span> عدد غير محدود من المناسبات</li>
                  <li className="d-flex align-items-center gap-2 small"><span className="material-symbols-outlined text-primary text-sm">check_circle</span> لوحة تحكم كاملة للمنظمين</li>
                  <li className="d-flex align-items-center gap-2 small"><span className="material-symbols-outlined text-primary text-sm">check_circle</span> تعاون الفريق (Team Collab)</li>
                  <li className="d-flex align-items-center gap-2 small"><span className="material-symbols-outlined text-primary text-sm">check_circle</span> هوية بصرية مخصصة بالكامل</li>
                  <li className="d-flex align-items-center gap-2 small fw-bold text-primary"><span className="material-symbols-outlined text-sm">support_agent</span> دعم فني ذو أولوية</li>
                </ul>
                <a href="mailto:youmak.egp@gmail.com" className="btn btn-dark w-100 py-3 fw-bold">تواصل معنا</a>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* ══════════════ ADD-ONS ══════════════ */}
      <section className="py-5 bg-surface-container-low">
        <div className="container px-4">
          <div className="row g-5 align-items-center">
            <div className="col-lg-5">
              <motion.h2 className="display-5 fw-black mb-4 leading-tight" style={{ fontFamily: 'var(--font-headline)', fontWeight: 900 }} {...fadeUp}>إضافات اختيارية<br/><span className="text-primary">لتميز مناسبتك</span></motion.h2>
              <motion.p className="text-on-surface-variant fs-5 arabic-leading mb-4" {...fadeUp}>صممنا لك مجموعة من الأدوات الإضافية لتجعل يومك أكثر سهولة وتنظيماً.</motion.p>
              <motion.img className="rounded-4 shadow-lg w-100 object-cover" style={{ aspectRatio: '16/9' }} src="https://lh3.googleusercontent.com/aida-public/AB6AXuB9Ag26k_WqI4oXBH5q8zxnZ5gg3160k5cmlg0SD29tdfwd7XkOwvaI1pBLGvskumITzwftbeZ9GFx6NhXy0PsRnlZ0H0dfrbLgh8fsoitBHapqJPtotnawnbuJeJJMKRm0NWFktzBKM5N7qiQ0RWJEdwRfc1zgBRXkKyIv58_n3Bse0vhwb8ZXWn-T0ovt_gnqzmfhs6J10xB-grnqLXOWFkZh9aJikoBXjf_nPqpC2RIfTQCJHYYAZXOxlIWPGdwSBG6I4xxo_hnQ" alt="Invitation Card" {...fadeUp} />
            </div>
            <div className="col-lg-7">
              <div className="row g-3">
                {[
                  { icon: "branding_watermark", title: "إزالة العلامة المائية", price: "49 ج.م" },
                  { icon: "palette", title: "تصميم مخصص", price: "99 ج.م" },
                  { icon: "videocam", title: "دعوة فيديو", price: "149 ج.م" },
                  { icon: "cloud_upload", title: "مساحة إضافية", price: "50 ج.م" },
                  { icon: "print", title: "طباعة الـ QR كود", price: "تواصل معنا", span: true }
                ].map((addon, i) => (
                  <div key={i} className={addon.span ? "col-12" : "col-sm-6"}>
                    <motion.div
                      className="bg-white p-4 rounded-4 d-flex align-items-center justify-content-between transition-soft border border-light"
                      whileHover={{ backgroundColor: 'var(--primary)', color: 'white' }}
                      {...fadeUp}
                    >
                      <div className="d-flex align-items-center gap-3">
                        <div className="rounded-circle d-flex align-items-center justify-content-center" style={{ width: '48px', height: '48px', backgroundColor: 'rgba(139, 73, 62, 0.1)' }}>
                          <span className="material-symbols-outlined">{addon.icon}</span>
                        </div>
                        <div className="text-end">
                          <h4 className="h6 fw-bold mb-0">{addon.title}</h4>
                          <span className="small opacity-60">{addon.price}</span>
                        </div>
                      </div>
                      <span className="material-symbols-outlined">{addon.icon === "print" ? "mail" : "add_circle"}</span>
                    </motion.div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ══════════════ COMPARISON ══════════════ */}
      <section className="py-5 bg-white">
        <div className="container px-4">
          <motion.h2 className="display-5 fw-black text-center mb-5" style={{ fontFamily: 'var(--font-headline)', fontWeight: 900 }} {...fadeUp}>قارن بين الخطط بكل تفصيل</motion.h2>
          <div className="table-responsive rounded-4 border border-light shadow-sm">
            <table className="table table-hover align-middle mb-0 text-end">
              <thead className="bg-surface-variant">
                <tr>
                  <th className="p-4 fw-bold">المميزات</th>
                  <th className="p-4 fw-bold text-center">المجانية</th>
                  <th className="p-4 fw-bold text-center" style={{ backgroundColor: 'rgba(139, 73, 62, 0.05)' }}>البداية</th>
                  <th className="p-4 fw-bold text-center">الاحترافية</th>
                  <th className="p-4 fw-bold text-center">الشركات</th>
                </tr>
              </thead>
              <tbody className="divide-y">
                {[
                  { f: "عدد المناسبات", v: ["1", "1", "1", "غير محدود"] },
                  { f: "عدد الصور", v: ["10", "غير محدود", "غير محدود", "غير محدود"] },
                  { f: "إزالة العلامة المائية", v: [false, true, true, true] },
                  { f: "نظام RSVP", v: [false, false, true, true] },
                  { f: "دعم مخصص", v: ["إيميل", "إيميل", "دردشة", "مدير حساب"] }
                ].map((row, i) => (
                  <tr key={i}>
                    <td className="p-4 fw-medium">{row.f}</td>
                    {row.v.map((val, j) => (
                      <td key={j} className={`p-4 text-center ${j === 1 ? 'bg-primary-dim/20' : ''}`}>
                        {typeof val === 'boolean' ? (
                          <span className={`material-symbols-outlined ${val ? 'text-primary' : 'text-danger'}`}>{val ? 'check' : 'close'}</span>
                        ) : val}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* ══════════════ SOCIAL PROOF / STATS ══════════════ */}
      <section className="py-5 bg-surface-container-low border-top border-bottom">
        <div className="container px-4">
          <div className="row g-4 text-center">
            <div className="col-md-4">
              <motion.div {...fadeUp}>
                <h3 className="display-4 fw-black text-primary mb-1">١٥٠ألف+</h3>
                <p className="fw-bold text-muted mb-0">مناسبة سعيدة حول العالم</p>
              </motion.div>
            </div>
            <div className="col-md-4">
              <motion.div {...stagger(0.1)}>
                <h3 className="display-4 fw-black text-primary mb-1">ملايين</h3>
                <p className="fw-bold text-muted mb-0">الذكريات تم حفظها للأبد</p>
              </motion.div>
            </div>
            <div className="col-md-4">
              <motion.div {...stagger(0.2)}>
                <h3 className="display-4 fw-black text-primary mb-1">#١</h3>
                <p className="fw-bold text-muted mb-0">المنصة الرائدة في مصر</p>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* ══════════════ TESTIMONIAL ══════════════ */}
      <section className="py-5 bg-surface-container-low overflow-hidden">
        <div className="container px-4">
          <div className="row g-5 align-items-center">
            <div className="col-md-6 position-relative">
              <div className="position-absolute top-0 start-0 w-75 h-75 rounded-circle blur-3xl opacity-20" style={{ backgroundColor: 'var(--primary)', zIndex: 0 }}></div>
              <motion.img className="rounded-4 shadow-2xl position-relative w-100 object-cover" style={{ height: '500px', zIndex: 1 }} src="https://lh3.googleusercontent.com/aida-public/AB6AXuB3migmfjYWLqQZqImCs2mNM1D2BwA5BbNn_3GWVMwM4qetexoiDm3T-xIs-VXQu2x6Yrv23WWTN0qsCXwmmmHbKDpke5ITe-DCGXfavBJLn717il6YEalERIaI2zbYgm1vR2AoCXjOWahmKke1Cz3r-NVrNBpvvgGcb2mTPdpZFrOUqVqHJmT6bY6j4w6ReVmjcsknsybAWOiEUPEu1F-M2aHAKE4CVRAJycfIv4dBLdtiNwJP9ozHXMPQDiOoCaOie6Paun-mYTCt" alt="Testimonial" {...fadeUp} />
            </div>
            <div className="col-md-6">
              <motion.span className="text-primary fw-bold tracking-widest text-uppercase mb-2 d-block" {...fadeUp}>آراء عملائنا</motion.span>
              <motion.blockquote className="display-5 fw-black italic leading-snug mb-4" style={{ fontFamily: 'var(--font-headline)' }} {...fadeUp}>
                "يومك خلى فرحنا مختلف تماماً، كل الصور وصلت لي في لحظتها!"
              </motion.blockquote>
              <motion.div className="d-flex align-items-center gap-3" {...fadeUp}>
                <div className="rounded-circle d-flex align-items-center justify-content-center fw-bold text-white bg-primary" style={{ width: '48px', height: '48px' }}>س</div>
                <div>
                  <p className="fw-bold mb-0">سارة، عروسة</p>
                  <div className="text-warning d-flex">
                    {[1, 2, 3, 4, 5].map(n => <span key={n} className="material-symbols-outlined text-sm" style={{ fontVariationSettings: "'FILL' 1" }}>star</span>)}
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* ══════════════ FAQ ══════════════ */}
      <section className="py-5 bg-white">
        <div className="container px-4" style={{ maxWidth: '800px' }}>
          <motion.h2 className="display-5 fw-black mb-5 text-center" style={{ fontFamily: 'var(--font-headline)', fontWeight: 900 }} {...fadeUp}>عندك استفسار؟ احنا هنا</motion.h2>
          <div className="accordion accordion-flush" id="faqAccordion">
            {faqs.map((faq, i) => (
              <motion.div key={i} className="accordion-item border-0 mb-3" {...fadeUp}>
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed rounded-4 bg-surface-variant text-on-surface fs-5 fw-bold p-4 shadow-none"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#faq${i}`}
                    style={{ fontFamily: 'var(--font-headline)' }}
                  >
                    {faq.q}
                  </button>
                </h2>
                <div id={`faq${i}`} className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                  <div className="accordion-body px-4 py-4 fs-5 text-on-surface-variant arabic-leading">
                    {faq.a}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ══════════════ FINAL CTA ══════════════ */}
      <section className="py-5 position-relative">
        <div className="container px-4 text-center position-relative z-10">
          <motion.div className="bg-primary p-5 p-md-5 rounded-5 shadow-2xl position-relative overflow-hidden" {...fadeUp}>
            <h2 className="display-4 fw-black text-white mb-4" style={{ fontFamily: 'var(--font-headline)', fontWeight: 900 }}>جاهز تبدأ تجمّع ذكرياتك؟</h2>
            <p className="fs-4 text-white opacity-80 mb-5 mx-auto" style={{ maxWidth: '600px' }}>انضم لآلاف المناسبات التي وثقت أجمل لحظاتها بذكاء وسهولة.</p>
            <div className="d-flex flex-column flex-sm-row justify-content-center gap-4">
              <Link to="/register" className="btn btn-light px-5 py-3 fw-black fs-5 text-primary shadow-lg transition-soft hover-scale">إنشاء حساب</Link>
              <a href="https://wa.me/201013201998" target="_blank" rel="noreferrer" className="btn btn-outline-light px-5 py-3 fw-bold fs-5 transition-soft">تحدث مع المبيعات</a>
            </div>
            {/* Abstract Graphics */}
            <div className="position-absolute top-0 end-0 w-25 h-25 rounded-circle blur-3xl opacity-20 translate-middle" style={{ backgroundColor: 'white' }}></div>
            <div className="position-absolute bottom-0 start-0 w-25 h-25 rounded-circle blur-3xl opacity-20 translate-middle" style={{ backgroundColor: 'var(--primary-light)' }}></div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
